import { optionTitle_pbpPublishingOptions } from './PublishPbpOption.locstring.json';
import { optionTitle_pbp } from './strings.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import getShownView from 'owa-pbp-option/lib/selectors/getShownView';
import PersonalBookingPageShownView from './data/store/schema/PersonalBookingPageShownView';

var lazyFullModule = new LazyModule(() => import('./lazyFullPublishPbpOption'));
let PublishPbpOption: LazyOption = createLazyOption(
    {
        key: 'publishPbpOption',
        titleStringKey: optionTitle_pbpPublishingOptions,
        searchTermsStringKey: optionTitle_pbp,
        isHidden: () => {
            return (
                !isFeatureEnabled('cal-personalbookingpage') ||
                getShownView() != PersonalBookingPageShownView.Main
            );
        },
    },
    lazyFullModule,
    m => m.default
);

export default PublishPbpOption;
